export const FORM_CONTROL_ID = 'dropdown-formControl';
export const VIEW_MODE_CONTAINER_ID = 'dropdown-viewMode-container';
export const LABEL_ID = 'dropdown-label';

export const ARIA_DROPDOWN_LABEL = 'dropdown-label';
export const ARIA_DROPDOWN_SELECT = 'dropdown-select';
export const ARIA_DROPDOWN_MENU_ITEM = 'dropdown-menu-item';
